import React from "react";
import classNames from "classnames";
import { WrappedFieldProps } from "redux-form";
import { Input, FormFeedback } from "reactstrap";

interface FormInputHiddenProps {
    name: string;
    disabled?: boolean;
    id?: string;
}

function FormInputHidden(props: WrappedFieldProps & FormInputHiddenProps): JSX.Element {
    const {
        input,
        name,
        disabled,
        id,
        meta: { error, touched },
    } = props;

    const hasError = touched && error != null;
    // And the input props.
    const inputProps: any = {
        name,
        disabled,
        invalid: hasError,
    };
    if (id != null) {
        inputProps.id = id;
    }
    if (hasError) {
        inputProps.valid = false;
    }
    return (
        <>
            <Input
                {...inputProps} {...input}
                type="hidden"
                className={classNames({"is-invalid": hasError})}
            />
            {hasError && <FormFeedback>{error}</FormFeedback>}
        </>
    );
}

export { FormInputHidden };
